function checkForStyleSheet(styleSheetToCheck) {
    let found = false;
    for (const styleSheet of document.styleSheets) {
        const href = styleSheet.href;
        if (href && href.indexOf(styleSheetToCheck) !== -1) {
            found = true;
            break;
        }
    }

    if (!found) {
        console.warn(`It seems that you forgot to add "${styleSheetToCheck}" to your page, that is ` +
            'why some information might not be visible on your map. You can find the missing asset on our ' +
            'Downloads page: https://developer.tomtom.com/maps-sdk-web-js/downloads');
    }

}

export default function(styleSheetsToCheck) {
    for (const styleSheetToCheck of styleSheetsToCheck) {
        checkForStyleSheet(styleSheetToCheck);
    }
}



// WEBPACK FOOTER //
// ./map/utils/cssStyleChecker.js